import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocRoleFilteringState = atom({
  key: "ocRoleFilteringState",
  default: {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
